"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _core = require("../core");

var _utils = require("../utils");

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    root: {
      marginTop: 0,
      marginBottom: 0
    },
    typographyRoot: {
      '&&': {
        color: 'inherit'
      }
    }
  };
}, {
  name: (0, _core.rochePrefix)('ListItemText')
});
exports.useStyles = useStyles;